import { Grid, Paper, Typography, IconButton, Tooltip, Tabs, Tab, FormControl, InputLabel, OutlinedInput, InputAdornment, Button } from '@mui/material';
import { DataGrid, GridColDef, gridClasses, GridCellParams } from '@mui/x-data-grid';
import { useEffect, useState, useRef } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import b64toBlob from 'b64-to-blob';

import WidgetLoading from '../../SmartDashboard/Shared/WidgetLoading';
import { dateFormatter } from '../../../utils/timeFormat';
import { fetchFuhFumOrHraFullProgramReferralTagWidget, exportFuhFumOrHraFullProgramReferralTagWidget } from '../../Widgets/WidgetService';
import { isDefaultDate } from '../../../utils/common';
import { parentUrl } from '../../../utils/constants';
import { Search } from '@mui/icons-material';
import { FuhFumTypeEnum } from '../../../Enum/FuhFumTypeEnum';

const FullProgramReferralTags = () => {
    const [rows, setRows] = useState<any>({});
    const [filteredRows, setFilteredRows] = useState([]);
    const [isFetched, setIsFetched] = useState<boolean>(false);
    const [downLoading, setDownLoading] = useState<boolean>(false);
    const [show, setShow] = useState(false);
    const [pageSize, setPageSize] = useState(15);
    const [page, setPage] = useState(0);
    const ref = useRef(null);
    const [tab, setTab] = useState(1);
    const [fullProgramTab, setFullProgramTab] = useState(1);
    const [memberSearchValue, setMemberSearchValue] = useState('');

    const handleClick = (event) => {
        setShow(!show);
    };

    const changeFilter = async () => {
        setIsFetched(false);
        const response = await fetchFuhFumOrHraFullProgramReferralTagWidget(memberSearchValue);
        setRows(response);
        let filterResponse = response?.FuhfumFullProgramReferrals.filter((m) => m.IsEnrolled);
        setFilteredRows(filterResponse);
        setIsFetched(true);
    };

    useEffect(() => {
        setIsFetched(false);
        changeFilter();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setIsFetched]);

    const columns: GridColDef[] = [
        {
            field: 'MemberName',
            headerName: 'Member Name',
            flex: 1,
            cellClassName: (params: GridCellParams) =>
                params.row.FuhFumType === FuhFumTypeEnum.FUH || params.row.FuhFumType === FuhFumTypeEnum.FUM
                    ? 'green'
                    : params.row.FuhFumType === FuhFumTypeEnum.PCR
                    ? 'blue'
                    : '',
        },
        {
            field: 'DOB',
            headerName: 'DOB',
            flex: 1,
            valueGetter: (value, row) => `${isDefaultDate(row.DOB) ? '-' : dateFormatter(new Date(row.DOB))}`,
            cellClassName: (params: GridCellParams) =>
                params.row.FuhFumType === FuhFumTypeEnum.FUH || params.row.FuhFumType === FuhFumTypeEnum.FUM
                    ? 'green'
                    : params.row.FuhFumType === FuhFumTypeEnum.PCR
                    ? 'blue'
                    : '',
        },
        {
            field: 'Address',
            headerName: 'Address',
            flex: 2,
            cellClassName: (params: GridCellParams) =>
                params.row.FuhFumType === FuhFumTypeEnum.FUH || params.row.FuhFumType === FuhFumTypeEnum.FUM
                    ? 'green'
                    : params.row.FuhFumType === FuhFumTypeEnum.PCR
                    ? 'blue'
                    : '',
        },
        {
            field: 'ReferralDate',
            headerName: 'Referral Date',
            flex: 1,
            valueGetter: (value, row) => `${isDefaultDate(row.ReferralDate) ? '-' : dateFormatter(new Date(row.ReferralDate))}`,
            cellClassName: (params: GridCellParams) =>
                params.row.FuhFumType === FuhFumTypeEnum.FUH || params.row.FuhFumType === FuhFumTypeEnum.FUM
                    ? 'green'
                    : params.row.FuhFumType === FuhFumTypeEnum.PCR
                    ? 'blue'
                    : '',
        },
        {
            field: 'AdmitDate',
            headerName: 'Admit Date',
            flex: 1,
            valueGetter: (value, row) => `${isDefaultDate(row.AdmitDate) ? '-' : dateFormatter(new Date(row.AdmitDate))}`,
            cellClassName: (params: GridCellParams) =>
                params.row.FuhFumType === FuhFumTypeEnum.FUH || params.row.FuhFumType === FuhFumTypeEnum.FUM
                    ? 'green'
                    : params.row.FuhFumType === FuhFumTypeEnum.PCR
                    ? 'blue'
                    : '',
        },
        {
            field: 'DischargeDate',
            headerName: 'Discharge Date',
            flex: 1,
            valueGetter: (value, row) => `${isDefaultDate(row.DischargeDate) ? '-' : dateFormatter(new Date(row.DischargeDate))}`,
            cellClassName: (params: GridCellParams) =>
                params.row.FuhFumType === FuhFumTypeEnum.FUH || params.row.FuhFumType === FuhFumTypeEnum.FUM
                    ? 'green'
                    : params.row.FuhFumType === FuhFumTypeEnum.PCR
                    ? 'blue'
                    : '',
        },
    ];

    const handleAlertsTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        let filterResponse = [];
        switch (newValue) {
            case 1: {
                filterResponse =
                    fullProgramTab === 1
                        ? rows?.FuhfumFullProgramReferrals.filter((m) => m.IsEnrolled)
                        : rows?.HraFullProgramReferrals.filter((m) => m.IsEnrolled);
                break;
            }
            case 2: {
                filterResponse =
                    fullProgramTab === 1
                        ? rows?.FuhfumFullProgramReferrals.filter((m) => !m.IsEnrolled)
                        : rows?.HraFullProgramReferrals.filter((m) => !m.IsEnrolled);
                break;
            }
        }
        setFilteredRows(filterResponse);
        setTab(newValue);
    };

    const handleFullProgramTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        let filterResponse = [];
        switch (newValue) {
            case 1: {
                filterResponse =
                    tab === 1 ? rows.FuhfumFullProgramReferrals?.filter((m) => m.IsEnrolled) : rows.FuhfumFullProgramReferrals?.filter((m) => !m.IsEnrolled);
                break;
            }
            case 2: {
                filterResponse =
                    tab === 1 ? rows.HraFullProgramReferrals?.filter((m) => m.IsEnrolled) : rows.HraFullProgramReferrals?.filter((m) => !m.IsEnrolled);
                break;
            }
        }
        setFilteredRows(filterResponse);
        setFullProgramTab(newValue);
    };

    const changeSearch = (event: any) => {
        if (!event.key || event.key === 'Enter') {
            changeFilter();
        }
    };

    const exportFuhFumOrHraFullProgramReferralTags = async () => {
        setDownLoading(true);
        const data = await exportFuhFumOrHraFullProgramReferralTagWidget(memberSearchValue);

        let blob = b64toBlob(data.base64String, 'text/csv');
        let url = window.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.href = url;
        var date = new Date();
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();
        var dateInfo = [(mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd, date.getFullYear()].join('');
        link.setAttribute('download', `FuhFumOrHraFullProgramReferralTag - ${dateInfo}.xlsx`);
        link.click();
        link.remove();
        setDownLoading(false);
    };

    const prepareColumns = () => {
        let columnsData = columns;
        if (fullProgramTab === 2) {
            columnsData = columnsData.filter((c) => c.field !== 'AdmitDate' && c.field !== 'DischargeDate');
        }
        return columnsData;
    };

    return (
        <Grid size={{ xs: 12, lg: 6 }}>
            <Paper
                className="smartdashboard-widget"
                elevation={5}
                sx={{ height: 'calc(100vh - 140px)', maxHeight: '650px', display: 'flex', flexDirection: 'column', overflow: 'auto' }}
            >
                <Grid container spacing={2} paddingLeft={2} paddingRight={2}>
                    <Grid size={12}>
                        <Typography color={'primary'} variant="h6" textAlign={'center'} ref={ref}>
                            <span className="pointer">FUHFUM / HRA Full Program Tag Referral</span>
                            <Tooltip
                                open={show}
                                title={
                                    <div>
                                        <Typography marginTop={1} fontWeight={800} variant="subtitle2">
                                            FUHFUM
                                        </Typography>
                                        <Typography variant="caption">
                                            FUHFUM members who are reffered to the full program and one requiring the 7-day follow-up (FUH/FUM) will be
                                            indicated in green, while the 30-day follow-up post-discharge (PCR) will be indicated in blue.
                                        </Typography>
                                        <div>
                                            <Typography marginTop={1} fontWeight={800} variant="subtitle2">
                                                Enrolled :
                                            </Typography>
                                            <Typography variant="caption">
                                                Indicates members who are enrolled in full program after the FUHFUM is complete.
                                            </Typography>
                                            <Typography marginTop={1} fontWeight={800} variant="subtitle2">
                                                Not Enrolled :
                                            </Typography>
                                            <Typography variant="caption">
                                                Members who are not enrolled in full program after 30 days of FUHFUM referral.
                                            </Typography>
                                        </div>
                                        <Typography marginTop={1} fontWeight={800} variant="subtitle2">
                                            HRA
                                        </Typography>
                                        <Typography variant="caption">HRA members who are reffered to the full program</Typography>
                                        <div>
                                            <Typography marginTop={1} fontWeight={800} variant="subtitle2">
                                                Enrolled :
                                            </Typography>
                                            <Typography variant="caption">Indicates members who are enrolled in full program.</Typography>
                                            <Typography marginTop={1} fontWeight={800} variant="subtitle2">
                                                Not Enrolled :
                                            </Typography>
                                            <Typography variant="caption">Members who are not enrolled in full program.</Typography>
                                        </div>
                                    </div>
                                }
                                PopperProps={{ style: { zIndex: 1000 } }}
                            >
                                <IconButton onClick={handleClick}>
                                    <InfoIcon sx={{ width: '18px', height: '18px' }} />
                                </IconButton>
                            </Tooltip>
                        </Typography>
                    </Grid>
                    <Grid size={10} display={'flex'} mb={2.5}>
                        <Tabs sx={{ display: 'inline-flex', marginRight: 'auto' }} value={fullProgramTab} onChange={handleFullProgramTabChange}>
                            <Tab value={1} label="FUHFUM" />
                            <Tab value={2} label="HRA" />
                        </Tabs>
                    </Grid>
                    <Grid size={2} display={'flex'} mb={2.5} mt={1} maxHeight="55px">
                        <Button
                            style={{ minWidth: '120px', marginLeft: 'auto' }}
                            onClick={() => exportFuhFumOrHraFullProgramReferralTags()}
                            variant="contained"
                            color="success"
                            disabled={filteredRows?.length === 0 || downLoading}
                        >
                            {downLoading ? 'Exporting..' : 'Export'}
                        </Button>
                    </Grid>
                    <Grid size={4}>
                        <FormControl size="small">
                            <InputLabel htmlFor="outlined-adornment-password">Search</InputLabel>
                            <OutlinedInput
                                id="outlined-adornment-password"
                                type="text"
                                value={memberSearchValue}
                                onChange={(e) => {
                                    setMemberSearchValue(e.target.value as string);
                                }}
                                onKeyUp={(event: any) => {
                                    changeSearch(event);
                                }}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton aria-label="Search" onClick={changeSearch} edge="end">
                                            <Search />
                                        </IconButton>
                                    </InputAdornment>
                                }
                                label="Search"
                            />
                        </FormControl>
                    </Grid>
                    <Grid size={4} style={{ paddingTop: '5px' }}></Grid>
                    <Grid size={4} style={{ paddingTop: '5px' }}>
                        <Tabs value={tab} onChange={handleAlertsTabChange} style={{ float: 'right' }}>
                            <Tab value={1} label="Enrolled" />
                            <Tab value={2} label="Not Enrolled" />
                        </Tabs>
                    </Grid>
                    <Grid size={12}>
                        <div style={{ width: '100%', height: 'calc(100vh - 350px)', maxHeight: '400px', position: 'relative' }}>
                            {!isFetched && <WidgetLoading />}
                            <Grid size={12}>
                                <div style={{ width: '100%', height: 'calc(100vh - 350px)', maxHeight: '390px' }}>
                                    <DataGrid
                                        onCellClick={(params: any) => {
                                            window.open(`${parentUrl}provider/members-list/member-chart/${params.row.Id}/member-profile`, '_blank');
                                        }}
                                        rows={filteredRows}
                                        columns={prepareColumns()}
                                        paginationModel={{ pageSize: pageSize, page: page }}
                                        pageSizeOptions={[5]}
                                        onPaginationModelChange={(model) => {
                                            setPageSize(model.pageSize);
                                            setPage(model.page);
                                        }}
                                        getRowId={(row) => row.Id}
                                        getRowHeight={() => 'auto'}
                                        sx={{
                                            [`& .${gridClasses.cell}`]: {
                                                py: 1,
                                            },
                                            '& .MuiDataGrid-root': {
                                                overflowX: 'auto',
                                            },
                                            [`& .green`]: {
                                                color: 'green',
                                            },
                                            [`& .red`]: {
                                                color: 'red',
                                            },
                                            [`& .blue`]: {
                                                color: '#4169E1',
                                            },
                                            [`& .black`]: {
                                                color: 'rgba(0,0,0,0.87)',
                                            },
                                        }}
                                    />
                                </div>
                            </Grid>
                        </div>
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    );
};

export default FullProgramReferralTags;
